<template>
  <div :class="$style.container">
    <HeadingMedium :class="$style.headText">
      {{ commandName }}
    </HeadingMedium>
    <GetStartedInstructions
      :class="$style.recommendedCommandQueue"
      :localStorageKey="localStorageKey"
      :showDismiss="false"
      :startCollapsed="false"
      title="command"
    >
      <CopyWell
        :class="$style.copyWell"
        :inlineLabel="false"
        :isEditable="false"
        :multiLine="true"
        :value="commandText"
      />
    </GetStartedInstructions>
    <CommandQueueDetailItemTable
      @command="id => fetchCommandDetail(id)"
    />
  </div>
</template>

<script>

import {
  CopyWell,
  HeadingMedium,
} from '@jumpcloud/ui-components';
import CommandQueueDetailItemTable from 'client/Commands/CommandQueueDetailItemTable';
import CommandsApi from 'client/api/v2/CommandsApi';
import Constants, { LocalStorageConsts } from 'client/util/Constants';
import GetStartedInstructions from 'client/components/GetStartedInstructions/GetStartedInstructions.vue';

const { instructionsCommandQueueDetailDismissed } = LocalStorageConsts;
const { dataNotAvailable } = Constants;

export default {
  name: 'CommandQueueDetailMainPanel',
  components: {
    GetStartedInstructions,
    CopyWell,
    HeadingMedium,
    CommandQueueDetailItemTable,
  },

  data() {
    return {
      localStorageKey: instructionsCommandQueueDetailDismissed,
      command: {},
    };
  },

  computed: {
    commandName() {
      return this.command ? this.command.name : dataNotAvailable;
    },

    commandText() {
      return this.command ? this.command.command : dataNotAvailable;
    },
  },

  methods: {
    fetchCommandDetail(id) {
      CommandsApi.fetchCommandDetail(id)
        .then(res => {
          if (res.status === 200) {
            this.command = res.data;
          }
        });
    },
  },
};
</script>

<style module>
.recommendedCommandQueue button {
  background: none;
  cursor: pointer;
  text-decoration: underline;
}

.copyWell {
  margin: 0 0 -2.5em 0;
  width: 100%;
}

.container {
  height: 100%;
}

/* Require "!important" to overwrite the default component styles because
  it has several selectors that weigh more than the class.

  Overrides https://github.com/TheJumpCloud/jumpcloud-ui-components/blob/master/src/components/Inputs/CopyWell/CopyWell.vue#L271
*/
.copyWell textarea {
  height: 12em !important;
}

.copyWell > span {
  font-size: 1rem !important;
  font-weight: 700 !important;
}

.headText {
  margin-left: 1em !important;
}
</style>
